import { Link } from "wouter";

export default function Footer() {
  return (
    <footer className="border-t mt-12 py-6 text-sm text-center text-gray-500">
      <div className="mb-2">
        &copy; {new Date().getFullYear()} ShowMe
      </div>

      <div className="flex justify-center flex-wrap gap-x-4 gap-y-1 px-4">
        <Link href="/legal/privacy" className="hover:underline hover:text-gray-700">Privacy Policy</Link>
        <Link href="/legal/terms" className="hover:underline hover:text-gray-700">Terms of Service</Link>
        <Link href="/legal/cookies" className="hover:underline hover:text-gray-700">Cookie Policy</Link>
        <Link href="/legal/accessibility" className="hover:underline hover:text-gray-700">Accessibility</Link>
        <Link href="/legal" className="hover:underline hover:text-gray-700">Legal</Link>
        <Link href="/support" className="hover:underline hover:text-gray-700">Support</Link>
      </div>

      <div className="mt-2 text-xs text-gray-400">
        ShowMe is a visual support tool and does not provide medical advice.
      </div>
    </footer>
  );
}
